import { Controller } from "@hotwired/stimulus";
import { Toast } from "bootstrap";

// Viser om skemaet er gemt. Tilstanden læses af Turbos egne hændelser, så
// beskeden altid afspejler den faktiske forespørgsel. Controlleren sidder på
// body og skriver kun i sit toasts-target.
const STATES = {
  pending: { text: "Ugemte ændringer", css: "text-bg-warning", autohide: false },
  saving: { text: "Gemmer …", css: "text-bg-secondary", autohide: false },
  saved: { text: "Alt er gemt", css: "text-bg-success", autohide: true },
  failed: { text: "Kunne ikke gemme", css: "text-bg-danger", autohide: false },
};

export default class extends Controller {
  static targets = ["toasts"];

  connect() {
    this.inFlight = 0;
    this.pending = false;
    // Turbo cacher sidens DOM. Ved en restore-visit kan en tidligere besked
    // ligge i cachen, så beholderen ryddes for at undgå dubletter.
    if (this.hasToastsTarget) this.toastsTarget.innerHTML = "";
    this.toastElement = null;
  }

  markPending() {
    this.pending = true;
    this.show("pending");
  }

  submitStart() {
    this.inFlight += 1;
    this.pending = false;
    this.show("saving");
  }

  submitEnd(event) {
    this.inFlight = Math.max(0, this.inFlight - 1);
    if (event.detail?.success === false) return this.show("failed");
    if (this.inFlight > 0 || this.pending) return;

    this.show("saved");
  }

  connectionError() {
    this.inFlight = 0;
    this.show("failed", "Ingen forbindelse til serveren");
  }

  // Advarer hvis noget endnu ikke er gemt.
  guardUnload(event) {
    if (this.inFlight === 0 && !this.pending) return;

    event.preventDefault();
    event.returnValue = "";
  }

  show(state, detail) {
    const config = STATES[state];
    if (!config || !this.hasToastsTarget) return;

    if (!this.toastElement) {
      this.toastElement = document.createElement("div");
      this.toastElement.className = "toast align-items-center border-0";
      this.toastElement.setAttribute("role", "status");
      this.toastElement.setAttribute("aria-live", "polite");
      // Fjernes af Turbo før siden caches, så beskeden ikke genopstår.
      this.toastElement.setAttribute("data-turbo-temporary", "");
      this.toastElement.innerHTML = '<div class="d-flex"><div class="toast-body"></div></div>';
      this.toastsTarget.appendChild(this.toastElement);
      this.toast = new Toast(this.toastElement, { autohide: false });
    }

    this.toastElement.className = `toast align-items-center border-0 ${config.css}`;
    this.toastElement.querySelector(".toast-body").textContent =
      detail ? `${config.text} — ${detail}` : config.text;
    this.toastElement.dataset.state = state;
    this.toast.show();

    clearTimeout(this.hideTimer);
    if (config.autohide) this.hideTimer = setTimeout(() => this.toast.hide(), 2500);
  }
}
